import { observer } from 'mobx-react-lite';
import { useEffect, useState } from 'react';
import { useStore } from '../../app/stores/store';
import { v4 as uuid } from 'uuid';
import {
  Dropdown,
  Checkbox,
  Header,
  Grid,
  GridRow,
  GridColumn,
  Message,
} from 'semantic-ui-react';
import { Button } from 'semantic-ui-react';
import { Activity } from '../../app/models/activity';
import DynamicTableComponent from './DynamicTableComponent';
import _ from 'lodash';
import { userLanguage } from '../../app/common/userLanguageSchema/userLanguage';
import DynamicTableFrontEnd from './DynamicTableFrontEnd';
import ScanModal from './ScanModal';
import { toast } from 'react-toastify';
import UnauthorizedMessage from '../UnauthorizedMessage';
import LoadingComponent from '../../app/layout/LoadingComponent';

type optionsType = {
  key: string;
  text: string;
  value: string;
  disabled?: boolean;
};

function AllocateUser() {
  const {
    reportStore,
    userStore,
    dashboardStore,
    clonedStore,
    activityStore,
    commonStore,
    departmentStore: {
      departmentsListByCustomerName,
      getDepartmentsByCustomer,
    },
  } = useStore();
  const { userReadableDateFormat } = commonStore;
  const { getUsers, user } = userStore;
  const { CheckUserById } = clonedStore;
  const { activitiesByDate, loadActivitiesPagination, allocateUserTableData } =
    activityStore;
  const { allocateItemToUserArray, allocateScannedItemToUserArray } =
    reportStore;

  const [openModal, setOpenModal] = useState(false);
  const [tableData, setTableData] = useState<Activity[]>([]);
  const [tableName, setTableName] = useState('AllocateUser');
  const [barCode, setBarCode] = useState<string[]>([]);
  const [pageNumber, setPageNumber] = useState(1);
  //   const [removeUserId, setRemoveUserId] = useState("");
  //   const [removeDisplayName, setRemoveDisplayName] = useState("");
  //   const [id, setId] = useState<string>("");
  // const [displayName, setDisplayName] = useState("");
  //   const [department, setDepartment] = useState(null);
  const [loader, setLoader] = useState(false);
  const [assignUserOptions, setAssignUserOptions] = useState<optionsType[]>([]);
  const [removeUserOptions, setRemoveUserOptions] = useState<optionsType[]>([]);
  const [departmentOptions, setDepartmentOptions] = useState<optionsType[]>([]);
  const [itemNotFound, setItemNotFound] = useState<string[]>([]);

  useEffect(() => {
    if (dashboardStore.dashboard.setTagTablePageNumber === 1) {
      setPageNumber(dashboardStore.dashboard.setTagTablePageNumber);
    }
  }, [dashboardStore.dashboard.setTagTablePageNumber]);

  useEffect(() => {
    dashboardStore.updateCountOrderMenu(user!.id);
    activityStore.loadActivitiesPagination(1, user!.id, 10);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    const tempData: Activity[] = [];
    activitiesByDate.forEach((a: any) => {
      delete a?.isMaster;
      // eslint-disable-next-line
      delete a?.sections_Multiple_From;
      delete a?.sections_From;
      delete a?.synopsis;

      tempData?.push({
        ...a,
        movementdate: userReadableDateFormat(a.movementdate),
        movement_Time: userReadableDateFormat(a.movement_Time),
        maintenance: userReadableDateFormat(a.maintenance),
        receivingdate: userReadableDateFormat(a.receivingdate),
        status_Time: userReadableDateFormat(a.status_Time),
        itemCreatedAt: userReadableDateFormat(a.itemCreatedAt),
      });
    });
    setTableData(tempData);
    // JSON.parse(JSON.stringify(tableData)).map((i: any) => removeCol.split(",").map((j) => delete i[j]));
    // eslint-disable-next-line
  }, [activitiesByDate]);

  useEffect(() => {
    const assignOptions: optionsType[] = [];
    const removeOptions: optionsType[] = [];
    const departmentBasedUsers: { id: string; displayName: string }[] = [];
    if (reportStore.AU_department) {
      getUsers?.forEach((user: any) => {
        if (user?.departmentName === reportStore.AU_department) {
          departmentBasedUsers.push({
            id: user?.id,
            displayName: user?.displayName,
          });
        }
      });
    } else {
      getUsers?.forEach((user: any) => {
        departmentBasedUsers.push({
          id: user?.id,
          displayName: user?.displayName,
        });
      });
    }
    departmentBasedUsers?.forEach(
      (user: { id: string; displayName: string }) => {
        // assignOptions?.push({
        //   key: user.id,
        //   text: user.displayName,
        //   value: user.id,
        //   disabled: reportStore.userIdOfSelectedItem.includes(user.id),
        // });
        if (reportStore.userIdOfSelectedItem.includes(user.id)) {
          removeOptions?.push({
            key: user.id,
            text: user.displayName,
            value: user.id,
          });
        } else {
          assignOptions?.push({
            key: user.id,
            text: user.displayName,
            value: user.id,
          });
        }
      },
    );
    setAssignUserOptions(assignOptions);
    setRemoveUserOptions(removeOptions);
    // eslint-disable-next-line
  }, [getUsers, reportStore.userIdOfSelectedItem, reportStore.AU_department]);

  useEffect(() => {
    if (departmentsListByCustomerName.length === 0) {
      getDepartmentsByCustomer(user?.customerName || '');
    }
    const departmentList = departmentsListByCustomerName.map((x) => ({
      key: x,
      text: x,
      value: x,
    }));
    setDepartmentOptions(departmentList);
    //eslint-disable-next-line
  }, [departmentsListByCustomerName]);

  useEffect(() => {
    let availableItems: string[] = barCode;
    allocateUserTableData?.forEach((itemInfo: any) => {
      if (availableItems.includes(itemInfo?.physical_sensor_barcode)) {
        availableItems = availableItems.filter(
          (itemCode) => itemCode !== itemInfo?.physical_sensor_barcode,
        );
      }
    });
    setItemNotFound(availableItems);
    // eslint-disable-next-line
  }, [barCode, allocateUserTableData]);

  const paginateFunction = (value: number) => {
    if (
      !_.isEmpty(dashboardStore.dashboard.searchfilterparams) &&
      Object.values(dashboardStore.dashboard.searchfilterparams).every(
        (o) => o !== '',
      ) &&
      dashboardStore.dashboard.orderData === '' &&
      dashboardStore.dashboard.orderName === ''
    ) {
      activityStore.searchListItems(
        dashboardStore.dashboard.searchfilterparams,
        value,
        10,
      );
    } else if (
      dashboardStore.dashboard.orderData !== '' &&
      dashboardStore.dashboard.orderName !== ''
    ) {
      activityStore.sortListItems(
        dashboardStore.dashboard.orderName,
        dashboardStore.dashboard.orderData,
        value,
        10,
      );
    } else {
      loadActivitiesPagination(value, user?.id, 10);
    }
    dashboardStore.setTagPageNumFunc(value);
    loadActivitiesPagination(value, user?.id, 10);
    setPageNumber(value);
  };

  const searchFunction = (column: any, order: any) => {
    <Checkbox label="This checkbox comes pre-checked" defaultChecked />;
  };

  const assignUser = (_event: any, data: any) => {
    if (reportStore.removeUserDDvalue.length) {
      reportStore.removeUserDDvalue = [];
      toast.info(
        'Please add user or remove user. Cannot Perform both actions.',
      );
    } else {
      if (data.value.length) {
        reportStore.AllocateUserDDValue = data.value;
        reportStore.AllocateUserDDValue?.forEach((userId: string) => {
          CheckUserById(userId);
        });
      } else {
        reportStore.AllocateUserDDValue = [];
      }
    }
  };

  const removeUser = (data: any) => {
    if (reportStore.AllocateUserDDValue.length) {
      reportStore.AllocateUserDDValue = [];
      toast.info(
        'Please add user or remove user. Cannot Perform both actions.',
      );
    } else {
      if (data.value.length) {
        reportStore.removeUserDDvalue = data.value;
        reportStore.removeUserDDvalue?.forEach((userId: string) => {
          CheckUserById(userId);
        });
      } else {
        reportStore.removeUserDDvalue = [];
      }
    }
  };

  const updateDepartment = (data: any) => {
    reportStore.AU_department = data.value;
    reportStore.getUserIdByItemIdAllocate(reportStore.allocateItemToUserArray);
    reportStore.removeUserDDvalue = [];
    reportStore.AllocateUserDDValue = [];
  };

  async function onSubmitScannedItems() {
    setTableName('AllocateUserScan');
    var input = document.getElementById(
      'myInputQuickscan',
    ) as HTMLTextAreaElement;
    const barcodeDetails = input.value.split('\n') as string[];
    barcodeDetails.pop();
    setBarCode(barcodeDetails);
    await activityStore.getScannedDataAllocateUser(barcodeDetails);
    setOpenModal(false);
  }

  async function handleAllocateUserSubmit() {
    setLoader(true);
    let submitClick = new Promise((resolve) => {
      //       if (
      //         reportStore.AllocateUserDDValue !== "" &&
      //         reportStore.removeUserDDvalue !== ""
      //       ) {
      //         reportStore.AllocateAndRemove(
      //           id,
      //           removeUserId,
      //           displayName,
      //           removeDisplayName,
      //           tableName
      //         );
      //       } else
      if (reportStore.AllocateUserDDValue.length) {
        reportStore.AllocateCheckbox(tableName);
      } else if (reportStore.removeUserDDvalue.length) {
        reportStore.RemoveUser(tableName);
      }
      resolve('');
    });
    submitClick.then(() => {
      let timer = setTimeout(async () => {
        if (tableName === 'AllocateUserScan') {
          await activityStore.getScannedDataAllocateUser(barCode);
        } else {
          await dashboardStore.updateCountOrderMenu(user!.id);
          await activityStore.loadActivitiesPagination(
            pageNumber,
            user!.id,
            10,
          );
        }
      }, 1000);
      setLoader(false);
      return () => clearTimeout(timer);
    });
  }
  // if(activityStore.loadCountAssetTable)  return (
  //        <div style={{ minHeight: "50px" }}>
  //               <LoadingComponent />
  //        </div>
  // );
  return (
    <>
      {dashboardStore.dashboard.loadingdata === 'loading' && (
        <div style={{ marginTop: '30px' }}>
          <LoadingComponent />
        </div>
      )}
      {dashboardStore.dashboard.loadingdata !== 'loading' &&
        !commonStore.filterModeOne?.includes('ALLU01') && (
          <UnauthorizedMessage />
        )}
      {commonStore.filterModeOne.includes('ALLU01') && (
        <>
          <Header
            style={{ marginLeft: '28px' }}
            icon="users"
            size="huge"
            dividing
            as="h1"
            content={
              (userLanguage[0].AllocateUser?.AUH01 as any)?.[
                `${commonStore.language.key}`
              ]
            } //"Allocate Users";
            sub
            color="grey"
          />
          <Grid>
            <GridRow style={{ gridGap: '15px', padding: '25px' }}>
              <GridColumn floated="right">
                {commonStore.filterModeTwo?.includes('AUB05') ? (
                  <></>
                ) : (
                  <Button
                    style={{ width: '100%' }}
                    onClick={() => setOpenModal(true)}
                    disabled={commonStore.filterModeZero?.includes('AUB05')}
                    primary
                  >
                    {
                      (userLanguage[0].AllocateUser?.AUB05 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Button>
                )}
              </GridColumn>
              <GridColumn style={{ width: '200px' }}>
                <Dropdown
                  options={departmentOptions}
                  placeholder="Select Department"
                  Search
                  selection
                  clearable
                  value={reportStore.AU_department || ''}
                  onChange={(_event: any, data: any) => updateDepartment(data)}
                ></Dropdown>
              </GridColumn>
              <GridColumn style={{ width: '200px' }}>
                <Dropdown
                  options={removeUserOptions}
                  placeholder={
                    reportStore.AU_department !== '' &&
                    removeUserOptions.length === 0 &&
                    reportStore.allocateItemToUserArray.length !== 0
                      ? '-- No User --'
                      : (userLanguage[0].AllocateUser?.AUB04 as any)?.[
                          `${commonStore.language.key}`
                        ]
                  }
                  Search
                  selection
                  clearable
                  multiple
                  disabled={
                    (allocateItemToUserArray.length === 0 &&
                      allocateScannedItemToUserArray.length === 0) ||
                    (reportStore.AU_department !== '' &&
                      removeUserOptions.length === 0)
                  }
                  value={reportStore.removeUserDDvalue}
                  onChange={(_event: any, data: any) => removeUser(data)}
                ></Dropdown>
              </GridColumn>
              <GridColumn style={{ width: '200px' }}>
                <Dropdown
                  options={assignUserOptions}
                  placeholder={
                    reportStore.AU_department !== '' &&
                    assignUserOptions.length === 0 &&
                    reportStore.allocateItemToUserArray.length !== 0
                      ? '-- No User --'
                      : (userLanguage[0].AllocateUser?.AUB03 as any)?.[
                          `${commonStore.language.key}`
                        ]
                  }
                  Search
                  selection
                  clearable
                  multiple
                  disabled={
                    (allocateItemToUserArray.length === 0 &&
                      allocateScannedItemToUserArray.length === 0) ||
                    (reportStore.AU_department !== '' &&
                      assignUserOptions.length === 0)
                  }
                  value={reportStore.AllocateUserDDValue}
                  onChange={(_event: any, data: any) =>
                    assignUser(_event, data)
                  }
                ></Dropdown>
              </GridColumn>
              <GridColumn style={{ width: '130px' }}>
                {commonStore.filterModeTwo?.includes('AUB02') ? (
                  <></>
                ) : (
                  <Button
                    onClick={handleAllocateUserSubmit}
                    positive
                    disabled={
                      (reportStore.AllocateUserDDValue.length === 0 &&
                        reportStore.removeUserDDvalue.length === 0) ||
                      commonStore.filterModeZero?.includes('AUB02')
                    } //Submit
                  >
                    {
                      (userLanguage[0].AllocateUser?.AUB02 as any)?.[
                        `${commonStore.language.key}`
                      ]
                    }
                  </Button>
                )}
              </GridColumn>
            </GridRow>
          </Grid>
          <div style={{ position: 'relative' }}>
            {JSON.parse(JSON.stringify(allocateUserTableData)).length > 0 ? (
              // loader ? (
              //   <LoadingComponent />
              // ) : (

              <DynamicTableFrontEnd
                data={allocateUserTableData}
                pageNumData={pageNumber}
                actiontype={''}
                name="AllocateUserScan"
                loading={loader}
              />
            ) : (
              // )
              // loader ? (
              //   <LoadingComponent />
              // ) :
              <DynamicTableComponent
                key={uuid()}
                data={tableData}
                name={'AllocateUser'}
                actiontype={''}
                pageFunc={paginateFunction}
                pageNumData={pageNumber}
                searchFuncData={searchFunction}
                loading={loader}
              />
            )}
            {openModal && (
              <ScanModal
                open={openModal}
                setOpen={setOpenModal}
                submitHandler={onSubmitScannedItems}
              />
            )}
          </div>
          {itemNotFound.length ? (
            <Message>
              <Message.Header>
                <p style={{ marginBottom: '12px' }}>Item(s) not found:</p>
              </Message.Header>
              <Message.Content>
                {itemNotFound?.map((barcode: string, index: number) => {
                  return <p key={index}>{barcode}</p>;
                })}
              </Message.Content>
            </Message>
          ) : null}
        </>
      )}
    </>
  );
}
export default observer(AllocateUser);
